import Axios from 'axios';
import type { RecipientType } from '@app/offer/OfferMessageSentPage/types';
import type { Listing } from 'api/ListingController/getListing';

type ListingAgentType = {
  name: string;
  org: string;
  email: string;
};

type sendOfferMessageDTO = {
  sentTo: string;
  agents: {
    recipients: ListingAgentType[];
    removed: ListingAgentType[];
    unsubscribed: RecipientType[];
  };
  listing: Listing;
  listingId: string;
  subject: string;
  body: string;
};

const sendOfferMessage = async (data: sendOfferMessageDTO) => {
  await Axios.post(`/listing/${data.listingId}/offer_message`, data);
};

export default sendOfferMessage;
